import dictionary from '../assets/localization';

export default {
  translate (key) {
    const currentLanguage = 'en';
    return dictionary[currentLanguage][key]
  }
}